import React, { useState } from 'react'
import { IconButton, InputAdornment } from '@mui/material'
import { EyeIcon, EyeOff } from 'lucide-react'
import BaseInput, { BaseInputProperties } from '@reusables/BaseInput'
import { FieldError } from 'react-hook-form';

interface BasePasswordInputProps extends BaseInputProperties {
    field?: any;
    error?: FieldError | string;
    label?: string;
    showPasswordCondition?: boolean;
}


export default function BasePasswordInput({ field, error, label, showPasswordCondition, ...props }: BasePasswordInputProps) {
    const [showPassword, setShowPassword] = useState(false);

    return (
        <BaseInput
            {...field}
            {...props}
            error={error}
            label={label}
            type={showPassword ? 'text' : 'password'}
            endAdornment={
                showPasswordCondition && (
                    <InputAdornment position="end" className="absolute right-4 top-1/2 -translate-y-1/2"
                    style={{ zIndex: 1 }}>
                        <IconButton
                            onMouseEnter={() => setShowPassword(true)}
                            onMouseLeave={() => setShowPassword(false)}
                            // onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                        >
                            {showPassword ? <EyeOff size={20} /> : <EyeIcon size={20} />}
                        </IconButton>
                    </InputAdornment>
                )
            }
        />
    )
}
